$(function () {
    if (!$('#edit-booking-from-email').length) return false;

    let booking_id = getURLParameter("booking_id");
    let secure_key = getURLParameter("secure_key");;

    $('#edit-booking-from-email').loadATLObject({
        endpoint: "bookings-anonymous",
        objectId: booking_id + '/' + secure_key,
        errorMessage: "Sorry, we couldn't retrieve the booking request you are looking for...<br />Please select one from the section 'My Bookings'.",
        errorRedirectURL: config.app_url + "/clients/my-bookings/",
        success: function (booking) {
            console.log(booking);
            $('#confirm-email').val(booking.email);
            $('#duration').val(booking.datetime.duration);
            $('#datetime').val(formatFieldValue(booking.datetime.datetime, 'datetime'));
            if (booking.language !== 'Other') { $('#other-language-name').hide(); }

            // Manage Job Code fields
            if (booking.job_code !== '') {
                $('input[name="job_code2"]').filter('[value="' + atl_client_parent_job_code(booking.job_code) + '"]').attr('checked', true);
            }          
            $('#' + booking.job_type).attr('checked', true);  

            showSubJobCodes(booking.job_type, atl_client_parent_job_code(booking.job_code));

            $('#' + booking.job_code).attr('checked', true);

            // Manage Job extra fields
            if (booking.job_type === 'onsite') {
                $('#job_location').val(booking.location);
            } else if (booking.job_type === 'teleconference') {
                $('#job_phone').val(booking.location);
            }
            if (booking.job_type !== 'onsite') {
                $('.onsite-field').addClass('hide');
            }
            if (booking.job_type !== 'teleconference') {
                $('.teleconference-field').addClass('hide');
            }
            if (booking.job_type !== 'videoconference') {
                $('.videoconference-field').addClass('hide');
            }

             // user submits booking form
             $('#submit-edit-from-email-form').on('click', function (e) {
                e.preventDefault();

                $('.centered-spinner').show();

                let form = $('form.booking-form');
                let form_data = getFormData(form);    
            
                // Check if the form is well completed
                if (!check_form_data(form_data, form)) {
                    $('.centered-spinner').hide();
                    return false;
                }

                let formData = new FormData(form[0]);
                formData.append('user_id', $('#user-id').val());
                $.ajax({
                    type: "POST",
                    url: getApiURL("bookings-anonymous") + '/' + booking.ID + '/' + secure_key,
                    headers: { "Token": $.cookie('token_api') },
                    data: formData,
                    cache: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        ATLAlerts.addSuccess(data.detail);
                        $('html, body').animate({ scrollTop: $('html').offset().top }, 1000);
                        $('#atl-alerts-div').append(ATLAlerts.displayAlerts(true));
                        $('.centered-spinner').hide();
                        return false;
                    },
                    error: function (request, textStatus, errorThrown) {
                        alert("Something went wrong: " + errorThrown);
                        ATLAlerts.addError(`Unable to edit the booking, please try again.`);
                        $('html, body').animate({ scrollTop: $('html').offset().top }, 1000);
                        $('#atl-alerts-div').append(ATLAlerts.displayAlerts(true));
                        $('.centered-spinner').hide();
                    }
                });
    
                console.log('Call API to update anonymous booking');
            });
        }
    });

    function check_form_data(form_data, form) {
        if (form_data['company'] === "") {
            alert("Please fill out the Name of Company / Individual field.");
            return false;
        }

        if (form_data['street_address'] === "") {
            alert("Please fill out the Street Address field.");
            return false;
        }

        if (form_data['state'] === "" || form_data['postcode'] === "" || form_data['suburb'] === "") {
            alert("Please fill out the City, Suburb and Postcode fields.");
            return false;
        }

        if (form_data['telephone'] === "") {
            alert("Please fill out the Telephone field");
            return false;
        }

        if (form_data['email'] === "") {
            alert("Please fill out the Email Address field");
            return false;
        }

        let email = form_data['email'];
        if (!isValidEmail(email)) {
            alert("Please enter a valid Email Address");
            return false;
        }

        if (email != $(form).find('#confirm-email').val()) {
            alert("The email and confirmation email addresses do not match");
            return false;
        }

        if ($(form).find("#additional-email-checkbox").is(":checked") && !isValidEmail($(form).find('#additional-email').val())) {
            alert("Please enter a valid Additional Email Address");
            return false;
        }

        if (!isFutureDate(form_data['datetime'])) {
            alert("Please enter a booking Date, Time in the future");
            return false;
        }

        if (!isValidDuration(form_data['duration'])) {
            alert("Please enter a valid duration");
            return false;
        }

        let language = form_data['language'];
        if (language === "" || (language === "Other" && form_data['language_name'] === '')) {
            alert("Please fill out the Language field");
            return false;
        }

        if (form_data['client'] === "") {
            alert("Please fill out the Client's Name field");
            return false;
        }

        if (form_data['job_reference'] === "") {
            alert("Please fill out the Claim No / Job Ref field");
            return false;
        }

        if (form_data['job_type'] === "") {
            alert("Please fill out the Job Type field");
            return false;
        }

        if (form_data['job_code'] === "") {
            alert("Please fill out the Job Code field");
            return false;
        }

        if (form_data['job_type'] !== 'teleconference' && form_data['job_code2'] === 'teleconference_short') {
            alert("Please fill out the Job Code field");
            return false;
        }

        if (form_data['contact_person'] === "") {
            alert("Please fill out the Contact Person field");
            return false;
        }

        if (form_data['job_type'] === 'onsite' && form_data['job_location'] === "") {
            alert("Please fill out the Job Location field");
            return false;
        }

        if (form_data['job_type'] === 'teleconference' && form_data['job_phone'] === "") {
            alert("Please fill out the Client Phone Number field");
            return false;
        }

        if (form_data['job_type'] === 'videoconference' && form_data['videoconference_info'] === "") {
            alert("Please fill out the Videoconference Info field");
            return false;
        }

        if (form_data['invoice_company'] === "") {
            alert("Please fill out the Invoice Company field");
            return false;
        }

        if (form_data['invoice_street_address'] === "") {
            alert("Please fill out the Street Address field");
            return false;
        }

        if (form_data['invoice_state'] === "" || form_data['invoice_postcode'] === "" || form_data['invoice_suburb'] === "") {
            alert("Please fill out the Invoice City, Suburb and Postcode fields.");
            return false;
        }

        if (form_data['instructed_by'] === "") {
            alert("Please fill out the Instructed By field");
            return false;
        }

        if (form_data['contact_phone'] === "") {
            alert("Please fill out the Contact Phone No. field");
            return false;
        }

        return true;
    }
});